import Timeline from 'bee-timeline'

export default Timeline
